import { createSelector } from '@reduxjs/toolkit';
import { CustomersListState } from './types';
import { RootState } from '../root-reducer';
import { stationsSelector } from '../stations/selectors';

export const rootSelector = (state: RootState): CustomersListState => state.CustomersList;

export const filtersSelector = createSelector(rootSelector, (state) => state.filters);

// Customers by station
export const customersByStationStatusSelector = createSelector(
  rootSelector,
  (state) => state.customersByStation.status
);
export const customersByStationErrorSelector = createSelector(rootSelector, (state) => state.customersByStation.error);
export const customersByStationDataSelector = createSelector(
  rootSelector,
  stationsSelector,
  ({ customersByStation: { data: customersByStationData } }, stations) => {
    return {
      ...customersByStationData,
      result: customersByStationData?.result?.map((service) => ({
        ...service,
        fluxClientStations: service.fluxClientStations.map((fluxClientStation) => ({
          ...fluxClientStation,
          stationFullName: stations
            ? stations.find((station) => station.uicStationCode === fluxClientStation.uicStation)?.name
            : undefined,
        })),
      })),
    };
  }
);

// Customers by OD
export const customersByODStatusSelector = createSelector(rootSelector, (state) => state.customersByOD.status);
export const customersByODErrorSelector = createSelector(rootSelector, (state) => state.customersByOD.error);
export const customersByODDataSelector = createSelector(
  rootSelector,
  stationsSelector,
  ({ customersByOD: { data: customersByODData } }, stations) => {
    return {
      ...customersByODData,
      result: customersByODData?.result?.map((service) => ({
        ...service,
        fluxClientODs: service.fluxClientODs.map((fluxClientItem) => ({
          ...fluxClientItem,
          fluxClientODDown: fluxClientItem.fluxClientODDown.map((downItem) => ({
            ...downItem,
            arrivalStationFullName: stations
              ? stations.find((station) => station.uicStationCode === downItem.arrivalStationUic)?.name
              : undefined,
          })),
          departureStationFullName: stations
            ? stations.find((station) => station.uicStationCode === fluxClientItem.departureStationUic)?.name
            : undefined,
        })),
      })),
    };
  }
);
